//let defaultColor = 'white',
let defaultColor = "#00e3fc",
  secondaryDefaultColor = "#cdcdcdff",
  activeColor = "#00e3fc7f",
  secondaryActiveColor = "#cdcdcdb2",
  handleDefaultColor = "#00000000",
  handleActiveColor = "#2386fe",
  // linkActiveColor = "#00e3fc40",
  // linkDeactiveColor = "#00e3fc60",
  linkActiveColor = "#80808040",
  linkDeactiveColor = "#80808060",
  fillColor = "transparent";

function setFillColor(color) {
  fillColor = color;
}

function getFillColor() {
  return fillColor;
}

function setToolColor(color) {
  defaultColor = color;
}

function getToolColor() {
  return defaultColor;
}

function setActiveColor(color) {
  activeColor = color;
}

function getActiveColor() {
  return activeColor;
}

function getColorIfActive(data) {
  if (data.color) {
    return data.color;
  }

  return data.active ? activeColor : defaultColor;
}

function getFreeformShapeStrokeColorIfActive(data) {
  return data.active ? "#00000000" : defaultColor;
}

function getFreeformShapeFillColorIfActive(data) {
  return data.active ? activeColor : "#00000000";
}

function getLinkColorIfActive(data) {
  if (data.color) {
    return data.color;
  }

  return data.active ? linkActiveColor : linkDeactiveColor;
}

function getSecondaryColorIfActive(data) {
  if (data.color) {
    return data.color;
  }

  return data.active ? secondaryActiveColor : secondaryDefaultColor;
}

function setHandleActiveColor(color) {
  handleActiveColor = color;
}

function getHandleActiveColor() {
  return handleActiveColor;
}

function getHandleColorIfActive(data) {
  // if (data.color) {
  //   return data.color;
  // }

  return data.active ? handleActiveColor : handleDefaultColor;
}

const toolColors = {
  setFillColor,
  getFillColor,
  setToolColor,
  getToolColor,
  getActiveColor,
  setActiveColor,
  getLinkColorIfActive,
  getColorIfActive,
  getFreeformShapeStrokeColorIfActive,
  getFreeformShapeFillColorIfActive,
  getSecondaryColorIfActive,
  setHandleActiveColor,
  getHandleActiveColor,
  getHandleColorIfActive
};

export default toolColors;
